/*------------------------------------------------
// File Name:PDM_BodyCheck_Tags.js
// File Description:PDM_BodyCheck_Tags store方法
// Author:zxl
// Create Time:2023/04/04 17:28:46
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_TagsList,
    GetPDM_BodyCheck_TagsListByPage,
    GetPDM_BodyCheck_TagsEntity,
    CreatePDM_BodyCheck_TagsEntity,
    UpdatePDM_BodyCheck_TagsEntity,
    DeletePDM_BodyCheck_TagsEntity,
} from '@/api/pdm/bodycheckTags'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckTags = {
    namespaced: true,
    state: {
        PdmBodycheckTagsList: [],
        PdmBodycheckTagsListLoading: false,
        PdmBodycheckTagsEntity: null,
        PdmBodycheckTagsShowDlg: false,
    },
    mutations: {
        setPdmBodycheckTagsList(state, dataList) {
            state.PdmBodycheckTagsList = [...dataList]
        },
        setPdmBodycheckTagsListLoading(state, visible) {
            state.PdmBodycheckTagsListLoading = visible
        },
        setPdmBodycheckTagsShowDlg(state, visible) {
            state.PdmBodycheckTagsShowDlg = visible
        },
        setPdmBodycheckTagsEntity(state, entity) {
            state.PdmBodycheckTagsEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmBodycheckTags({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_TagsEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTagsEntity', res.Data)
                        commit('setPdmBodycheckTagsShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmBodycheckTagsEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTagsListLoading', true)
                GetPDM_BodyCheck_TagsEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTagsEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTagsListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmBodycheckTagsList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTagsListLoading', true)
                GetPDM_BodyCheck_TagsList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTagsList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTagsListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmBodycheckTagsListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckTagsListLoading', true)
                GetPDM_BodyCheck_TagsListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTagsList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckTagsListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmBodycheckTags({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_TagsEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckTagsShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_Tags
        actEditPdmBodycheckTagsData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckTagsID : entity.PdmBodycheckTagsID
                }
                GetPDM_BodyCheck_TagsEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckTagsEntity', res.Data)
                        commit('setPdmBodycheckTagsShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_Tags ,传对象过来
        actEditPdmBodycheckTags({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckTagsEntity', entity)
                commit('setPdmBodycheckTagsShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_Tags
        actDeletePdmBodycheckTags({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_BodyCheck_TagsEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckTagsShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


